import React from "react";
import logo from "../assets/inplass-white-trimmed.png";

/**
 * Official iNPLASS white/transparent brand logo (trimmed for tight fit).
 * Imported via bundler so it is fingerprinted and cache-busted.
 */
export default function Logo({ className = "", size = "md" }) {
  const heights = { sm: "h-6", md: "h-8 md:h-9", lg: "h-10 md:h-12" };
  return (
    <img
      src={logo}
      alt="iNPLASS"
      className={`${heights[size]} w-auto select-none ${className}`}
      data-testid="inplass-logo"
      draggable={false}
      onError={(e) => {
        if (!e.currentTarget.dataset.fallback) {
          e.currentTarget.dataset.fallback = "1";
          e.currentTarget.src = "/brand/inplass-white-trimmed.png";
        }
      }}
    />
  );
}
